import React from 'react';
import bemCn from 'bem-cn';
import './style.scss';

const b = bemCn('sniff-button');

const SniffButton = ({ children, component, block = false, size = 'md', color = 'primary', className = '', ...rest }) => {
    const ToRender = component ? component : 'button';
    return (
        <ToRender className={b({ size, color, block }) + ' ' + className} {...rest}>
            {children}
        </ToRender>
    );
};

export default SniffButton;
